import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            laatsteJaarMetWaardeDeltaT: null,
            deltaT: null,
        }
    },
    mutations: {
        setLaatsteJaarMetWaardeDeltaT(state, jaar) {
            state.laatsteJaarMetWaardeDeltaT = jaar
        },
        setDelTaT(state,deltaT){
            state.deltaT = deltaT
        }
    },
    actions: {
        fetchLaatsteJaarMetWaardeDeltaT({commit}) {
            axiosInstance.get("/zon/ontwikkel/laatsteJaarDeltaT")
                .then(result => commit('setLaatsteJaarMetWaardeDeltaT', result.data))
        },
        saveNieuweWaardeDeltaT({commit}, waarde) {
            axiosInstance.post("/zon/ontwikkel/nieuwDeltaT/" + waarde)
                .then(result => commit('setLaatsteJaarMetWaardeDeltaT', result.data))
        },
        async fetchDeltaTVanJaar({commit},jaar){
            await axiosInstance.get("/zon/ontwikkel/deltaTVanJaar/" + jaar)
                .then(result => commit('setDelTaT', result.data))
        },
        pasDeltaTAan({commit},deltaTWaardeDto) {
            axiosInstance.put("/zon/ontwikkel/wijzigDeltaT",deltaTWaardeDto)
                .then((result) => commit('setDelTaT', result.data))
        }
    },
}